import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const services = [
    { name: 'Yangın Tüpü Satış', path: '/hizmetlerimiz/yangin-tupu-satis' },
    { name: 'Yangın Tüpü Dolum', path: '/hizmetlerimiz/yangin-tupu-dolum' },
    { name: 'Yangın Tüpü Bakım', path: '/hizmetlerimiz/yangin-tupu-bakim' },
    { name: 'Yangın Söndürme Ekipmanları', path: '/hizmetlerimiz/yangin-sondurme-ekipmanlari' },
    { name: 'Baca Temizliği', path: '/hizmetlerimiz/baca-temizligi' },
    { name: 'Davlumbaz Temizliği', path: '/hizmetlerimiz/davlumbaz-temizligi' },
    { name: 'Otomatik Davlumbaz Söndürme', path: '/hizmetlerimiz/otomatik-davlumbaz-sondurme-sistemi' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-primary-600 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <h1 className="text-3xl font-bold text-white font-display tracking-wide drop-shadow-[0_2px_8px_rgba(255,255,255,0.3)] hover:drop-shadow-[0_4px_12px_rgba(255,255,255,0.5)] transition-all" style={{ fontFamily: "'Montserrat', 'Poppins', sans-serif" }}>
              İpek Yangın Söndürme
            </h1>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/') ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              Anasayfa
            </Link>

            {/* Services Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <button
                className={`font-medium transition-colors flex items-center cursor-pointer whitespace-nowrap ${
                  location.pathname.startsWith('/hizmetlerimiz')
                    ? 'text-white'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                Hizmetlerimiz
                <i className={`ri-arrow-down-s-line ml-1 transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-lg shadow-xl border border-dark-100 py-2">
                  {services.map((service, index) => (
                    <Link
                      key={index}
                      to={service.path}
                      className="block px-4 py-3 text-dark-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {service.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/urunler"
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/urunler') ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              Ürünler
            </Link>

            <Link
              to="/kurumsal"
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/kurumsal') ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              Kurumsal
            </Link>

            <Link
              to="/blog"
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/blog') ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              Blog
            </Link>

            <Link
              to="/sss"
              className={`font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isActive('/sss') ? 'text-white' : 'text-white/80 hover:text-white'
              }`}
            >
              S.S.S.
            </Link>

            <Link
              to="/iletisim"
              className="bg-white text-primary-600 px-6 py-2.5 rounded-lg font-semibold hover:bg-white/90 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              İletişim
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-white/20">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/') ? 'text-white' : 'text-white/80'
                }`}
              >
                Anasayfa
              </Link>

              <div>
                <button
                  onClick={() => setIsServicesOpen(!isServicesOpen)}
                  className="font-medium text-white/80 flex items-center justify-between w-full cursor-pointer"
                >
                  Hizmetlerimiz
                  <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
                </button>
                {isServicesOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    {services.map((service, index) => (
                      <Link
                        key={index}
                        to={service.path}
                        onClick={() => setIsMenuOpen(false)}
                        className="block py-2 text-white/70 hover:text-white cursor-pointer"
                      >
                        {service.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/urunler"
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/urunler') ? 'text-white' : 'text-white/80'
                }`}
              >
                Ürünler
              </Link>

              <Link
                to="/kurumsal"
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/kurumsal') ? 'text-white' : 'text-white/80'
                }`}
              >
                Kurumsal
              </Link>

              <Link
                to="/blog"
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/blog') ? 'text-white' : 'text-white/80'
                }`}
              >
                Blog
              </Link>

              <Link
                to="/sss"
                onClick={() => setIsMenuOpen(false)}
                className={`font-medium transition-colors cursor-pointer ${
                  isActive('/sss') ? 'text-white' : 'text-white/80'
                }`}
              >
                S.S.S.
              </Link>

              <Link
                to="/iletisim"
                onClick={() => setIsMenuOpen(false)}
                className="bg-white text-primary-600 px-6 py-2.5 rounded-lg font-semibold text-center cursor-pointer"
              >
                İletişim
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
